import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Box, Paper } from '@material-ui/core';
import HelpPanel from './HelpPanel';
import HelpRegister from './pages/HelpRegister';
import HelpBusinessProfile from './pages/HelpBusinessProfile';
import HelpBusinessJobEdit from './pages/HelpBusinessJobEdit';
import HelpBusinessJobUpdate from './pages/HelpBusinessJobUpdate';

const useStyles = makeStyles((theme) => ({
    container: {
        width: '100%',
    },
    heading: {
        fontSize: '2.4rem',
        fontWeight: 700,
        color: '#26344a',
        marginBottom: '2rem',
        textAlign: 'center',
    },
    accordionContainer: {
        marginBottom: theme.spacing(3),
    },
}));

const HelpBusiness = () => {
    const classes = useStyles();

    return (
        <Box className={classes.container}>
            <Typography variant="h2" className={classes.heading}>
                企業・雇用主アカウント
            </Typography>

            <Box className={classes.accordionContainer}>
                <HelpPanel title="アカウント登録">
                    <HelpRegister business={true} />
                </HelpPanel>
            </Box>

            <Box className={classes.accordionContainer}>
                <HelpPanel title="企業紹介編集">
                    <HelpBusinessProfile />
                </HelpPanel>
            </Box>

            <Box className={classes.accordionContainer}>
                <HelpPanel title="求人投稿・編集">
                    <HelpBusinessJobEdit />
                </HelpPanel>
            </Box>

            <Box className={classes.accordionContainer}>
                <HelpPanel title="求人の再告知">
                    <Paper className={classes.info} elevation={0}>
                        <Typography variant="body1" className={classes.infoText}>
                            <strong style={{ color: '#ff3860' }}>
                                更新日が古い求人広告は読まれ難い傾向があります。
                            </strong>
                        </Typography>
                        <Typography variant="body1" className={classes.infoText}>
                            その為、継続的に求人を募集する際は定期的に求人再告知を行う事をお勧めします。（その際更新日は自動的に変更されます）
                        </Typography>
                    </Paper>
                    <HelpBusinessJobUpdate />
                </HelpPanel>
            </Box>
        </Box>
    )
}

export default HelpBusiness
